import { render, staticRenderFns } from "./mzbJjhfr.vue?vue&type=template&id=2b552fb4&scoped=true&"
import script from "./mzbJjhfr.vue?vue&type=script&lang=js&"
export * from "./mzbJjhfr.vue?vue&type=script&lang=js&"
import style0 from "./mzbJjhfr.vue?vue&type=style&index=0&id=2b552fb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b552fb4",
  null
  
)

export default component.exports